import React, {Component} from 'react';
//import flag from '../img/a.png';
class Footer extends Component {
    
    
    render() {
       
            return (

<footer className="py-5 bg-light">
    <div className="container">
       
        <div className="row my-2">
            <div className="col-md-8 mx-auto text-muted text-center small-xl">
                &copy; 2022 react-ig-feed <br/>Built with <span style={{color: '#e25555'}} className="heart">❤</span> in Atlas mountains by <a href="https://github.com/MohammedRaji/">Mohammed RAJI</a><br/> All Rights Reserved
            </div>
        </div>
    </div>
</footer>

                

            );

        }

    }


export default Footer;


